var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 32,
    viewBox: "0 0 155 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.343 0.444465C112.185 0.96171 105.861 7.67904 105.861 16.0492C105.963 24.5238 112.491 31.2411 120.751 31.5511H139.822C148.084 31.1383 154.407 24.421 154.508 16.0492C154.508 7.57457 147.981 0.754469 139.619 0.444465H120.343ZM120.649 8.50629C116.774 8.91906 113.816 12.1219 113.816 16.0492C113.917 19.9765 116.569 23.0765 120.343 23.491H139.619C143.596 23.181 146.451 19.9765 146.451 16.0492C146.451 12.1219 143.799 9.02182 140.026 8.50629H120.649ZM53.4403 0.444465V31.5511H83.8325C92.3987 31.7583 99.4352 24.731 99.5383 16.0492C99.5383 7.78181 93.4179 1.06447 85.2591 0.444465H53.4403ZM61.3946 8.50629V23.491H84.7503C88.6244 23.181 91.4809 19.9765 91.5823 16.0492C91.5823 12.1219 88.7275 8.91906 84.8518 8.50629H61.3946ZM0 0.444458L19.2738 31.5511H28.1476L47.2186 0.444458H38.0406L23.66 23.801L9.07659 0.444458H0Z",
    fill: "#234D96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c75466f517006fe61652335805b919fc.svg";
export { ForwardRef as ReactComponent };